import { createSlice } from "@reduxjs/toolkit";
import { getCertificationList } from "./thunk";

const getComplianceList = createSlice({
    name: "getComplianceList",
    initialState: {
        isLoading: false,
        isError: false,
        data: [],
    },
    extraReducers: (builder) => {
        builder
            .addCase(getCertificationList.pending, (state) => {
                state.isLoading = true;
                state.isError = false;
            })
            .addCase(getCertificationList.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload;
            })
            .addCase(getCertificationList.rejected, (state) => {
                state.isError = true;
                state.isLoading = false;
            })
    }
});

export default getComplianceList.reducer;